import { useTranslation } from 'react-i18next';
import { AdmissionCard } from '@components/admission-card/src/admission-card';
import {
  ADMISSION_CARD_TAG_ACCESS_CODE,
  ADMISSION_CARD_TAG_IMPORT_ONLY,
  AdmissionCardTag,
} from '@components/admission-card/src/admission-card.type';
import { ModalStickyHeader } from '@components/modals/modal-sticky-header';
import { Pass } from '@domain/passes';
import classNames from 'classnames';

import { Props } from './select-trigger-pass-modal.type';

export const SelectTriggerPassModal = ({ handleClose, onSelect, passes, passId }: Props) => {
  const { t } = useTranslation();
  const passesAvailable = passes.some((p) => p.id !== passId && p.quantity !== null);

  const handlePassClick = (pass: Pass): void => {
    onSelect(pass);
  };

  const renderPass = (pass: Pass) => {
    if (pass.id === passId || pass.quantity === null) return null;

    let tags: AdmissionCardTag[] = pass.accessCode ? [ADMISSION_CARD_TAG_ACCESS_CODE] : [];
    if (pass.settings.isPrivate) tags = [...tags, ADMISSION_CARD_TAG_IMPORT_ONLY];

    return (
      <AdmissionCard
        key={pass.id}
        id={pass.id}
        timezone=''
        color={pass.color ?? ''}
        name={pass.displayName}
        description={pass.displayDescription}
        quantity={pass.quantity}
        soldItems={0}
        currency={pass.price.currency}
        amount={pass.price.amount}
        isPrivate={pass.settings.isPrivate}
        isPublished={false}
        needsUserVerified={false}
        salesEnds={0}
        tags={tags}
        status={pass.status}
        showSubmenuIcon={false}
        onClick={() => handlePassClick(pass)}
        isPreset={true}
        isPassCard={true}
      />
    );
  };

  return (
    <div data-testid='select-trigger-pass-modal--container'>
      <ModalStickyHeader title={t('passes:selectTriggerPassTitle')} handleClose={handleClose} bordered={true} />

      <div className='flex flex-col justify-center items-center px-4 md:px-10 py-6'>
        <p className='text-sm text-tertiary text-left w-full'>{t('passes:selectTriggerPassDescription')}</p>
        {!passesAvailable && (
          <div
            data-testid='select-trigger-pass-modal--no-passes-available'
            className='flex justify-center items-center h-12 text-subtitle-s text-primary'>
            {t('offers:offerNotAvailable')}
          </div>
        )}
        <div className={classNames('mt-5 space-y-3 w-full', { hidden: !passesAvailable })}>
          {passes.map(renderPass)}
        </div>
      </div>
    </div>
  );
};
